import type { MultiSelectOption } from '../components/common/MultiSelectFilter/MultiSelectFilter';
import { ALL_PORTAL_ROLES } from '../utils/permissions';
import { PORTAL_ROLE_LABELS } from '../types/portalUser';

export const PORTAL_ROLE_OPTIONS: MultiSelectOption[] = ALL_PORTAL_ROLES.map((role) => ({
  value: role,
  label: PORTAL_ROLE_LABELS[role],
}));
